export const addCenterWhenFits = (emblaApi, className = 'is-centered') => {
	const container = emblaApi.containerNode();

	const toggleCentered = () => {
		const fits = !emblaApi.canGoToNext() && !emblaApi.canGoToPrev();
		container.classList.toggle(className, fits);
	};

	toggleCentered();

	emblaApi
		.on('reinit', toggleCentered)
		.on('resize', toggleCentered);
};
